import { render, staticRenderFns } from "./WidgetsReportFullInvoice.vue?vue&type=template&id=e7b45506&scoped=true"
import script from "./WidgetsReportFullInvoice.vue?vue&type=script&lang=js"
export * from "./WidgetsReportFullInvoice.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportFullInvoice.vue?vue&type=style&index=0&id=e7b45506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b45506",
  null
  
)

export default component.exports